import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {
      /* never reveal outcome — always show the same confirmation */
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex mb-8"><Logo height={30} /></Link>
        {sent ? (
          <div data-testid="forgot-confirmation">
            <div className="w-12 h-12 rounded-full bg-[#E7EFE6] flex items-center justify-center mb-4"><MailCheck className="w-6 h-6 text-[#4F6A4C]" /></div>
            <h1 className="text-3xl font-bold tracking-tight text-[#2A2626]">Check your inbox</h1>
            <p className="mt-2 text-[#5C5856]">If an account exists for that email, we've sent a password reset link. It expires in 30 minutes.</p>
            <Link to="/login"><Button className="mt-8 h-11 bg-[#2A2626] hover:bg-black text-white rounded-full px-6" data-testid="forgot-back-to-login">Back to sign in</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="text-3xl font-bold tracking-tight text-[#2A2626]">Forgot password?</h1>
            <p className="mt-2 text-[#5C5856]">Enter your account email and we'll send you a link to reset it.</p>
            <form onSubmit={submit} className="mt-8 space-y-5">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-11" data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={busy} className="w-full h-11 bg-[#2A2626] hover:bg-black text-white rounded-full" data-testid="forgot-submit">
                {busy ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <p className="mt-6 text-sm text-[#5C5856] text-center">
              Remembered it? <Link to="/login" className="text-[#2A2626] font-medium hover:underline" data-testid="forgot-login-link">Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
